import { Component, OnInit } from "@angular/core";
import { AudioPlayerComponent } from "ngx-audio-player";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseService } from "../base.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog } from "@angular/material/dialog";
import { AddToPlaylistComponent } from "../add-to-playlist/add-to-playlist.component";
import { ShareMusicContentComponent } from "../share-music-content/share-music-content.component";
import * as CryptoJS from "crypto-js";
import { ThrowStmt } from "@angular/compiler";

@Component({
  selector: "app-music-player",
  templateUrl: "./music-player.component.html",
  styleUrls: ["./music-player.component.css"],
  providers: [AudioPlayerComponent],
})
export class MusicPlayerComponent implements OnInit {
  status = true;
  isLogin: boolean;
  isActive = false;
  appConstant: any;
  button: any;
  thumbnails: any;
  songSrc: any;
  output_url: any;
  playerStatus = true;
  public_id: any;
  musicDetail: any = [];
  songlist: any = [];
  selectedIndex = 0;
  encodeUrl: any;
  type: any;
  model: any = {};
  playlistThumbnail: any;
  typeContent: any;
  constructor(
    public audiocomponent: AudioPlayerComponent,
    private route: ActivatedRoute,
    public service: BaseService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.public_id = this.route.snapshot.paramMap.get("id").split("?")[0];
    const paramType = this.route.snapshot.paramMap.get("id").split("=")[1];
    if (paramType?.split("&")[0] === "playList") {
      this.type = "playList";
      this.playListDetail();
    } else if (paramType?.split("&")[0] === "musicDetail") {
      this.type = "musicDetail";
      this.model.type = this.route.snapshot.paramMap.get("id").split("=")[2];
      this.model.public_id = this.public_id;
      this.getMusicDetail();
    }
    if (localStorage.getItem(environment.localStorageKey)) {
      this.isLogin = true;
    }
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(this.router.url),
      environment.secretkey
    ).toString();
    this.appConstant = environment;
    this.route.queryParamMap.subscribe((params: any) => {
      if (params.params.type === "playList") {
        this.type = params.params.type;
        this.playListDetail();
      } else if (params.params.type === "musicDetail") {
        this.type = params.params.type;
        this.model.type = params.params.slug;
        this.model.public_id = this.public_id;
        this.getMusicDetail();
      }
    });
    if (history.state.index) {
      this.selectedIndex = history.state.index;
    }
  }
  singIn(event: any, ind: any) {
    this.router.navigate(["/login"], {
      queryParams: {
        public_id: this.encodeUrl,
        event: event,
        index: ind,
        slug: this.model.type,
      },
    });
  }
  addToPlayList(data: any) {
    const dialogRef = this.dialog.open(AddToPlaylistComponent, {
      panelClass: "song-dialog",
      data: data,
      closeOnNavigation: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isActive = !this.isActive;
    });
  }

  openShareContent() {
    const dialogRef = this.dialog.open(ShareMusicContentComponent, {
      panelClass: "song-dialog",
      data: this?.songlist[this.selectedIndex],
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isActive = !this.isActive;
    });
  }
  classActive() {
    this.isActive = !this.isActive;
  }
  play(song, ind) {
    this.playerStatus = false;
    if (song === "play_all" || song === "complete") {
      this.service.audioStatus = !this.service.audioStatus;
      this.songSrc = this.musicDetail.songs[this.selectedIndex];
      this.output_url =
        this?.musicDetail?.songs[this.selectedIndex]?.output_url;
      this.contentType(this.selectedIndex);
      const data = {
        public_id: this.songSrc.public_id,
        album_id: this.musicDetail.public_id,
        partner_id: this.songSrc.posted_id,
        device_type: "web",
        type: this.model.type,
      };
      // this.service.songDetail(data).subscribe((res) => { });
      this.playerStatus = true;
    } else {
      if (!this.button && ind === this.selectedIndex) {
        this.service.audioStatus = !this.service.audioStatus;
        this.playerStatus = true;
      } else {
        this.selectedIndex = ind;
        const data = {
          public_id: song.public_id,
          album_id: this.musicDetail.public_id,
          partner_id: song.posted_id,
          device_type: "web",
          type: this.model.type,
        };
        // this.service.songDetail(data).subscribe((res) => { });
        this.songSrc = song;
        this.output_url = song?.output_url;
        this.contentType(this.selectedIndex);
        this.status = true;
        setTimeout(() => {
          this.playerStatus = true;
        }, 100);
        this.button = "";
      }
    }
  }
  getMusicDetail() {
    // this.spinner.show();
    this.service.musicDetail(this.model).subscribe(
      (res) => {
        this.musicDetail = res;
        this.songlist = this.musicDetail.songs;
        this.output_url = this?.songlist[this.selectedIndex]?.output_url;
        this.songSrc = this.songlist[this.selectedIndex];
        this.contentType(this.selectedIndex);
        this.loginCheck();
        // this.spinner.hide();
      },
      (err) => {
        // this.spinner.hide();
      }
    );
  }

  playListDetail() {
    this.service.playListDetail(this.public_id).subscribe(
      (res) => {
        this.musicDetail = res;
        this.songlist = this.musicDetail.songs;
        this.musicDetail.total_song = this.songlist.length;
        this.output_url = this?.songlist[this.selectedIndex]?.output_url;
        this.songSrc = this.songlist[this.selectedIndex];
        this.songlist.map((el) => {
          el.thumbnails.map((thumbnail) => {
            if (thumbnail.image_type === "square") {
              this.playlistThumbnail = thumbnail.asset;
            }
          });
          if (!this.playlistThumbnail) {
            this.playlistThumbnail = this.appConstant.playListImg;
          }
        });
        this.loginCheck();
        // this.spinner.hide();
      },
      (err) => {
        // this.spinner.hide();
      }
    );
  }
  loginCheck() {
    if (history.state.event === "Add_to_playlist") {
      this.isActive = true;
      this.addToPlayList(this.songlist[this.selectedIndex]);
    } else if (history.state.event === "Add_to_favorite") {
      if (!this.songlist[this.selectedIndex].is_favorite.id) {
        this.favoriteSong(
          this.songlist[this.selectedIndex],
          this.selectedIndex
        );
      }
    } else if (history.state.event === "Add_to_favorites") {
      this.isActive = true;
      if (!this.songlist[this.selectedIndex].is_favorite.id) {
        this.favoriteSong(
          this.songlist[this.selectedIndex],
          this.selectedIndex
        );
      }
    }
  }
  songPlay(event) {
    if (event.button === "next") {
      this.button = event.button;
      if (this.songlist.length > this.selectedIndex + 1) {
        this.selectedIndex = this.selectedIndex + 1;
        this.play(
          this.musicDetail.songs[this.selectedIndex],
          this.selectedIndex
        );
      } else {
        this.selectedIndex = 0;
        this.play(
          this.musicDetail.songs[this.selectedIndex],
          this.selectedIndex
        );
      }
    } else if (event.button === "prev") {
      this.button = event.button;
      if (this.selectedIndex > 0) {
        this.selectedIndex = this.selectedIndex - 1;
        this.play(
          this.musicDetail.songs[this.selectedIndex],
          this.selectedIndex
        );
      }
    }
  }
  songStatus(event) {
    if (event.status === "complete") {
      this.selectedIndex = this.selectedIndex + 1;
      this.play(event.status, this.selectedIndex);
    }
    if (event.audioStatus === "false") {
      this.service.audioStatus = false;
    }
  }

  favoriteSong(event, ind) {
    const id = {
      favorite_id: event.public_id,
      type:
        this.model.type == "music"
          ? "album"
          : this.model.type == "podcast"
          ? "podcast"
          : "",
    };
    if (event.is_favorite) {
      if (!event.is_favorite.id) {
        this.service.addFavorite(id).subscribe(
          (detail) => {
            this.songlist[ind].is_favorite.id = detail.id;
            this.songlist[ind].is_favorite.is_favorite = "yes";
            this.toastr.success("Added to Favorite", "Success!", {
              positionClass: "toast-bottom-left",
              closeButton: true,
            });
          },
          (err) => {
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      } else {
        this.service.removeFavorite(event.is_favorite.id).subscribe(
          (detail) => {
            this.songlist[ind].is_favorite.id = "";
            this.songlist[ind].is_favorite.is_favorite = "no";
            this.toastr.success("Removed from Favorite", "Success!", {
              positionClass: "toast-bottom-left",
              closeButton: true,
            });
          },
          (err) => {
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      }
    }
  }

  getImage(ind) {
    let src;
    if (ind >= 0) {
      let item = this.musicDetail?.songs[ind]?.thumbnails.filter(
        (item) => item.image_type === "square"
      );
      if (item?.length === 0) {
        if (this.type === "musicDetail") {
          this.musicDetail?.thumbnails.filter((el) => {
            if (el.image_type === "square") {
              src = el.asset;
            } else {
              src = environment.squareDefault;
            }
          });
        } else if (this.type === "playList") {
          src = environment.squareDefault;
        }
        return src;
      } else {
        return item[0]?.asset;
      }
    }
  }
  contentType(index: any) {
    this.typeContent = this?.songlist[index]?.output_url.split(".").pop();
    if (this.typeContent == "mp3") {
      this.typeContent = "audio/mp3";
    } else if (this.typeContent == "mp4") {
      this.typeContent = "video/mp4";
    } else {
      this.typeContent = "application/x-mpegURL";
    }
  }
  deleteSong(data: any, ind: any) {
    let model = {
      song_id: data.public_id,
      playlist_id: this.musicDetail.id,
    };
    this.service.songdelete(model).subscribe(
      (res) => {
        if (res) {
          this.songlist.splice(ind, 1);
          this.toastr.success(res.message, "Success!", {
            positionClass: "toast-bottom-left",
            closeButton: true,
          });
        }
      },
      (err) => {
        this.toastr.error(err.error.message, "OOPS!", {
          closeButton: true,
        });
      }
    );
  }

  ngOnDestroy() {
    this.dialog.closeAll();
  }
}
